import { PageHandler } from 'components/ContentHandlers'
import { generateWebPageProps } from 'utils/next'
import { setPageCacheControlHeaders } from 'utils/cache'
import FEATURE_TOGGLES from 'constants/featureToggles'
import { fetchAuthors } from 'services/contentful/helpers'
import { AUTHOR_LIMIT_DEFAULT } from 'services/contentful/constants'

export async function getServerSideProps(context) {
  setPageCacheControlHeaders(context.res)
  const serverSideProps = await generateWebPageProps(context)

  // Retrieve the authors from Contentful with the skip value based on the page number
  const skip = context?.query?.page ? (context?.query?.page - 1) * AUTHOR_LIMIT_DEFAULT : 0
  const authors = await fetchAuthors(skip)

  // Push all of the authors content into the sectionContents array of the PaginatedAuthorsList section
  serverSideProps?.props?.content?.fields?.sections?.map((section) => {
    if (section?.fields?.uiComponent == 'PaginatedAuthorsList') {
      section.fields.sectionContents.push({
        fields: {
          fieldName: 'listAuthors',
          authorsList: authors.items,
          total: authors.total,
        },
      })
    }
  })

  const authorsEnabled =
    serverSideProps?.props?.featureToggleObject?.[
      FEATURE_TOGGLES[process.env.NEXT_PUBLIC_SITE_ENVIRONMENT].ACX_WEB_ENABLE_AUTHORS
    ]
  if (!authorsEnabled) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    }
  }

  return serverSideProps
}

export default function Authors({ content, isMobile }) {
  return <PageHandler pageContent={content} isMobileUA={isMobile} />
}
